(() => {

  var CollectionBundleHighlightApp = (() => {
    const maxWidth = 1180;
    var setPaddingWidthProperty = () => {
      document.querySelectorAll('[js-collection-bundle-highlight]').forEach(element => {
        element.style.setProperty('--padding-left', (element.clientWidth - maxWidth) / 2 + 'px');
      });
    }
    var initialize = () => {
      window.dispatchEvent(new Event('resize'));
      window.addEventListener('resize', () => {
        setPaddingWidthProperty();
      })
    }
    return {
      init: initialize
    }
  })();


  var AnchorApp = (() => {
    var initialize = () => {
      if (window.location.hash === '#bundles') {
        setTimeout(() => {
          const bundlesSection = document.querySelector('#bundles') || document.querySelector('.product-bundle__desktop') || document.querySelector('.product-bundle__mobile');
          if (bundlesSection) {
            window.scrollTo(0, bundlesSection.getBoundingClientRect().top - 100 + window.scrollY);
          }
        }, 500);
      }
      if (window.location.hash === '#mobile-pdp-size-picker') {
        setTimeout(() => {
          if (window.innerWidth < 960) {
            const targetSection = document.querySelector('.product__size-picker.desktop-hide');
            if (targetSection) {
              window.scrollTo(0, targetSection.getBoundingClientRect().top - 100 + window.scrollY);
            }
          }
        }, 500);
      }
    }
    return {
      init: initialize
    }
  })();

  // Custom dropdown initialization function
  var initializeCustomDropdowns = () => {
    document.querySelectorAll('[js-custom-option-select]:not(.select-hidden)').forEach(function(selectElement) {
        var numberOfOptions = selectElement.children.length;
        var optionName = selectElement.dataset.optionName
        if(optionName) {
            optionName = optionName + ' : '
        } else {
            optionName = ''
        }
        selectElement.classList.add('select-hidden');

        var wrapper = document.createElement('div');
        wrapper.className = 'select';
        selectElement.parentNode.insertBefore(wrapper, selectElement);
        wrapper.appendChild(selectElement);

        var styledSelect = document.createElement('div');
        styledSelect.className = 'select-styled';
        styledSelect.textContent = optionName + selectElement.querySelector("option[selected]").textContent;
        wrapper.appendChild(styledSelect);

        var list = document.createElement('ul');
        list.className = 'select-options';
        wrapper.appendChild(list);

        for (var i = 0; i < numberOfOptions; i++) {
            var listItem = document.createElement('li');
            listItem.textContent = selectElement.children[i].textContent;
            listItem.setAttribute('rel', selectElement.children[i].value);
            list.appendChild(listItem);

            if (selectElement.children[i].selected) {
                listItem.classList.add('is-selected');
            }
        }

        var listItems = list.children;

        styledSelect.addEventListener('click', function(e) {
            e.stopPropagation();
            document.querySelectorAll('div.select-styled.active').forEach(function(activeStyledSelect) {
                if (activeStyledSelect !== styledSelect) {
                    activeStyledSelect.classList.remove('active');
                    activeStyledSelect.nextElementSibling.style.display = 'none';
                }
            });
            styledSelect.classList.toggle('active');
            list.style.display = styledSelect.classList.contains('active') ? 'block' : 'none';
        });

        styledSelect.insertAdjacentHTML('beforeend', `<div class="select-styled-icon"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 0.984374L7 4.98438L13 0.984375" stroke="#2B2B2B" stroke-linecap="round" stroke-linejoin="round"/>
</svg></div>`);

        Array.from(listItems).forEach(function(listItem) {
            listItem.addEventListener('click', function(e) {
                e.stopPropagation();
                let optionName = styledSelect.closest('.select').querySelector('select').dataset.optionName
                if(optionName) {
                    optionName = optionName + ' : '
                } else {
                    optionName=''
                }
                styledSelect.textContent = optionName + listItem.textContent;
                
                styledSelect.classList.remove('active');
                selectElement.value = listItem.getAttribute('rel');
                list.querySelector('li.is-selected').classList.remove('is-selected');
                listItem.classList.add('is-selected');
                list.style.display = 'none';
                styledSelect.insertAdjacentHTML('beforeend', `<div class="select-styled-icon"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 0.984374L7 4.98438L13 0.984375" stroke="#2B2B2B" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                </div>`);
                selectElement.dispatchEvent(new Event('change', {'view': window,'bubbles': true}))
            });

        });

        document.addEventListener('click', function() {
            styledSelect.classList.remove('active');
            list.style.display = 'none';
        });
    });
  };

  var ProductMeasurementInfoWrapperApp = (() => {
    var switchElement = (variant_id) => {
      document.querySelectorAll('[js-product-measurement-info-wrapper]').forEach(element => {
        if (element.getAttribute('data-variant-id') == String(variant_id)) {
          element.classList.add('active');
        } else {
          element.classList.remove('active');
        }
      });
    }
    var initialize = () => {
      document.addEventListener('product:variant-change', (event) => {
        switchElement(event.detail.variant.id)
      });
    }
    return {
      init: initialize
    }
  })();

  var PDPSizePickerApp = (() => {
    var initializeAllAnimations = (container) => {
      if (!container) return;

      container.querySelectorAll('.animation-fade-up-reveal:not(.animation-initialized)').forEach(element => {
        element.classList.add('animation-initialized');
      });
    };

    // Helper: ensure only one [name="id"] (hidden) is submitted
    var normalizeIdInputs = (formEl, variantId) => {
      if (!formEl) return;
      // Remove name from any non-hidden id fields to avoid duplicate submission
      formEl.querySelectorAll('[name="id"]').forEach(node => {
        if (!(node.tagName && node.tagName.toLowerCase() === 'input' && node.type === 'hidden')) {
          node.setAttribute('data-name', 'id');
          node.removeAttribute('name');
          // Also disable to prevent accidental serialization by libraries
          node.disabled = true;
        }
      });
      // Ensure hidden input exists and has correct value
      let hidden = formEl.querySelector('input[type="hidden"][name="id"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'id';
        formEl.appendChild(hidden);
      }
      if (variantId) hidden.value = variantId;
    };

    // Helper: set [name="id"] based on current option selections
    var syncHiddenIdFromOptions = () => {
      try {
        const productSection = document.querySelector('.shopify-section[data-section-type="product"]') || document;
        const sectionEl = productSection.querySelector('[data-section-id]') || document.querySelector('[data-section-id]');
        const formEl = productSection.querySelector('form[data-product-form]') || document.querySelector('form[data-product-form]');
        if (!sectionEl || !formEl) {
          console.log('[PDPSizePicker] syncHiddenIdFromOptions: missing section/form', { hasSection: !!sectionEl, hasForm: !!formEl });
          return;
        }
        let productData;
        const productJsonEl = document.querySelector('#ProductJson-' + sectionEl.getAttribute('data-section-id'));
        if (productJsonEl) {
          try { productData = JSON.parse(productJsonEl.textContent); } catch(_) {}
        } else if (window.__pdpProductData) {
          productData = window.__pdpProductData;
          console.log('[PDPSizePicker] syncHiddenIdFromOptions: using cached product data');
        } else {
          console.log('[PDPSizePicker] syncHiddenIdFromOptions: missing productJson, using fallbacks');
        }

        // Gather selected option values in order from variants block, then form, then section
        const variantsWrap = productSection.querySelector('[data-product-variants]');
        let optionInputs = [];
        if (variantsWrap) optionInputs = Array.from(variantsWrap.querySelectorAll('[name^="options"]'));
        if (!optionInputs.length) optionInputs = Array.from(formEl.querySelectorAll('[name^="options"]'));
        if (!optionInputs.length) optionInputs = Array.from(productSection.querySelectorAll('[name^="options"]'));
        const selectedOptions = optionInputs.map(input => input.value);

        // Try resolve via product data + options first
        let variantIdToUse;
        if (productData && productData.variants && selectedOptions.length) {
          const matched = productData.variants.find(v => v && v.options && selectedOptions.every((val, idx) => String(v.options[idx]) === String(val)));
          if (matched) variantIdToUse = matched.id;
        }

        // Fallbacks in order
        if (!variantIdToUse) {
          const currentVariantIdAttr = variantsWrap?.getAttribute('data-current-variant-id');
          if (currentVariantIdAttr) {
            variantIdToUse = currentVariantIdAttr;
            console.log('[PDPSizePicker] syncHiddenIdFromOptions: used data-current-variant-id', { variantIdToUse });
          }
        }
        if (!variantIdToUse && formEl.dataset.currentProductId) {
          variantIdToUse = formEl.dataset.currentProductId;
          console.log('[PDPSizePicker] syncHiddenIdFromOptions: used form dataset currentProductId', { variantIdToUse });
        }
        if (!variantIdToUse) {
          const idSelect = formEl.querySelector('select[data-name="id"], select[name="id"]');
          const value = idSelect?.value || idSelect?.getAttribute('value');
          if (value) {
            variantIdToUse = value;
            console.log('[PDPSizePicker] syncHiddenIdFromOptions: used fallback idSelect', { id: value });
          }
        }

        if (variantIdToUse) {
          normalizeIdInputs(formEl, variantIdToUse);
          formEl.setAttribute('data-current-product-id', variantIdToUse);
          console.log('[PDPSizePicker] syncHiddenIdFromOptions: set id', { selectedOptions, variantIdToUse });
        } else {
          console.log('[PDPSizePicker] syncHiddenIdFromOptions: no variant resolved', { selectedOptions });
        }
      } catch (e) {
        console.log('syncHiddenIdFromOptions failed:', e);
      }
    };

    // Helper: fully reinitialize the product section via Shopify Sections API
    var reinitProductSection = () => {
      try {
        const productSection = document.querySelector('.shopify-section[data-section-type="product"]');
        if (!productSection) {
          console.log('[PDPSizePicker] reinitProductSection: no product section found');
          return;
        }
        if (window.Shopify && window.Shopify.theme && window.Shopify.theme.sections) {
          if (typeof window.Shopify.theme.sections.unload === 'function') {
            console.log('[PDPSizePicker] sections.unload called');
            window.Shopify.theme.sections.unload(productSection);
          }
          if (typeof window.Shopify.theme.sections.load === 'function') {
            console.log('[PDPSizePicker] sections.load called');
            window.Shopify.theme.sections.load(productSection);
          } else {
            const evt = new Event('shopify:section:load');
            productSection.dispatchEvent(evt);
            console.log('[PDPSizePicker] dispatched shopify:section:load');
          }
        } else {
          const evt = new Event('shopify:section:load');
          productSection.dispatchEvent(evt);
          console.log('[PDPSizePicker] fallback section load event dispatched');
        }
      } catch (e) {
        console.log('reinitProductSection failed:', e);
      }
    };

    // Helper: compute selected variant from current option inputs
    var getSelectedVariantFromForm = () => {
      try {
        const productSection = document.querySelector('.shopify-section[data-section-type="product"]') || document;
        const sectionEl = productSection.querySelector('[data-section-id]') || document.querySelector('[data-section-id]');
        if (!sectionEl) return null;
        const productJsonEl = document.querySelector('#ProductJson-' + sectionEl.getAttribute('data-section-id'));
        let productData;
        if (productJsonEl) {
          try { productData = JSON.parse(productJsonEl.textContent); } catch(_) {}
        }
        if (!productData && window.__pdpProductData) {
          productData = window.__pdpProductData;
          console.log('[PDPSizePicker] getSelectedVariantFromForm: using cached product data');
        }
        const variantsWrap = productSection.querySelector('[data-product-variants]');
        const formEl = productSection.querySelector('form[data-product-form]') || document.querySelector('form[data-product-form]');
        let optionInputs = [];
        if (variantsWrap) optionInputs = Array.from(variantsWrap.querySelectorAll('[name^="options"]'));
        if (!optionInputs.length && formEl) optionInputs = Array.from(formEl.querySelectorAll('[name^="options"]'));
        if (!optionInputs.length) {
          optionInputs = Array.from(productSection.querySelectorAll('[name^="options"]'));
          console.log('[PDPSizePicker] getSelectedVariantFromForm: using section-scoped options', { count: optionInputs.length });
        }
        const selectedOptions = optionInputs.map(input => input.value);
        // If we have product data, try to resolve full variant
        if (productData && productData.variants) {
          let variant = null;
          if (selectedOptions.length) {
            variant = productData.variants.find(v => v && v.options && selectedOptions.every((val, idx) => String(v.options[idx]) === String(val))) || null;
          }
          if (!variant && formEl) {
            const idSelectEl = formEl.querySelector('select[name="id"]');
            const idVal = idSelectEl?.value || formEl.dataset.currentProductId;
            if (idVal) {
              variant = productData.variants.find(v => String(v.id) === String(idVal)) || null;
              if (variant) console.log('[PDPSizePicker] getSelectedVariantFromForm: resolved by select id', { id: idVal });
            }
          }
          return variant;
        }
        // Fallback: no product data; return minimal variant using select id or data-current-variant-id
        const idSelectEl = formEl?.querySelector('select[name="id"]');
        const idVal = idSelectEl?.value || formEl?.dataset.currentProductId || variantsWrap?.getAttribute('data-current-variant-id');
        if (idVal) {
          const minimalVariant = { id: Number(idVal) || idVal };
          console.log('[PDPSizePicker] getSelectedVariantFromForm: minimal variant created', minimalVariant);
          return minimalVariant;
        }
        return null;
      } catch (_) { return null; }
    };

    // Helper: lightly update UI for selected variant (price, data-current-variant-id)
    var applySelectedVariantUI = (variant) => {
      try {
        if (!variant) return;
        const productSection = document.querySelector('.shopify-section[data-section-type="product"]') || document;
        const variantsContainer = productSection.querySelector('[data-product-variants]');
        if (variantsContainer) {
          variantsContainer.setAttribute('data-current-variant-id', variant.id);
        }
        const formEl = productSection.querySelector('form[data-product-form]') || document.querySelector('form[data-product-form]');
        if (formEl) {
          formEl.setAttribute('data-current-product-id', variant.id);
        }
        // Simple price update (fallback if theme bindings are missing)
        const priceEl = productSection.querySelector('[data-price]');
        if (priceEl && typeof variant.price === 'number') {
          const price = (variant.price / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          priceEl.textContent = price;
        }
        const compareEl = productSection.querySelector('[data-compare-price]');
        if (compareEl && typeof variant.compare_at_price === 'number' && variant.compare_at_price > variant.price) {
          const compare = (variant.compare_at_price / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          compareEl.textContent = compare;
        }
        // Notify listeners
        document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant } }));
        console.log('[PDPSizePicker] variant UI applied', { id: variant.id });
      } catch (e) { console.log('[PDPSizePicker] applySelectedVariantUI error', e); }
    };

    // Bind variant option listeners with delegation and logs
    var bindVariantOptionListeners = () => {
      try {
        const productSection = document.querySelector('.shopify-section[data-section-type="product"]') || document;
        const variantsWrap = productSection.querySelector('[data-product-variants]');
        const formEl = productSection.querySelector('form[data-product-form]') || document.querySelector('form[data-product-form]');
        let optionInputs = [];
        if (variantsWrap) optionInputs = Array.from(variantsWrap.querySelectorAll('[name^="options"]'));
        if (!optionInputs.length && formEl) optionInputs = Array.from(formEl.querySelectorAll('[name^="options"]'));
        if (!optionInputs.length) optionInputs = Array.from(productSection.querySelectorAll('[name^="options"]'));
        console.log('[PDPSizePicker] bindVariantOptionListeners: binding', { count: optionInputs.length });
        optionInputs.forEach(input => {
          input.addEventListener('change', () => {
            const currentValues = optionInputs.map(i => i.value);
            console.log('[PDPSizePicker] option change detected', { currentValues });
            syncHiddenIdFromOptions();
            const variant = getSelectedVariantFromForm();
            console.log('[PDPSizePicker] computed variant on change', { id: variant?.id });
            if (variant) applySelectedVariantUI(variant);
          });
        });

        // Delegated listener as safety net
        const delegatedHandler = (e) => {
          const target = e.target;
          if (!target || !target.matches('[name^="options"]')) return;
          if (!productSection.contains(target)) return;
          let inputs = [];
          if (variantsWrap) inputs = Array.from(variantsWrap.querySelectorAll('[name^="options"]'));
          if (!inputs.length && formEl) inputs = Array.from(formEl.querySelectorAll('[name^="options"]'));
          if (!inputs.length) inputs = Array.from(productSection.querySelectorAll('[name^="options"]'));
          const currentValues = inputs.map(i => i.value);
          console.log('[PDPSizePicker] delegated option change', { currentValues });
          syncHiddenIdFromOptions();
          const variant = getSelectedVariantFromForm();
          console.log('[PDPSizePicker] delegated computed variant', { id: variant?.id });
          if (variant) applySelectedVariantUI(variant);
        };
        if (!window.__pdpOptionDelegatedHandler) {
          window.__pdpOptionDelegatedHandler = delegatedHandler;
          document.addEventListener('change', window.__pdpOptionDelegatedHandler, true);
          console.log('[PDPSizePicker] delegated option listener attached');
        }
      } catch (e) {
        console.log('[PDPSizePicker] bindVariantOptionListeners error', e);
      }
    };

    var reinitializeGallery = () => {
      if (window.productGallerySlider) {
        try {
          window.productGallerySlider.destroy();
          window.productGallerySlider = null;
        } catch (e) {
          console.log('Error destroying main slider:', e);
        }
      }

      if (window.productThumbnailSlider) {
        try {
          window.productThumbnailSlider.destroy();
          window.productThumbnailSlider = null;
        } catch (e) {
          console.log('Error destroying thumbnail slider:', e);
        }
      }

      const mainSliderElement = document.querySelector("[js-product-main-slider]");
      if (mainSliderElement) {
        if (window.flu && window.flu.chunks && window.flu.chunks.flickity) {
          import(window.flu.chunks.flickity).then(({ Flickity }) => {
            const mainSlider = new Flickity('[js-product-main-slider]', {
              contain: true,
              adaptiveHeight: true,
              prevNextButtons: true,
              wrapAround: false,
              pageDots: false,
              cellAlign: 'left',
              draggable: true
            });

            let thumbnailSlider;
            const thumbnailElement = document.querySelector("[js-product-thumbnail-slider]");
            if (thumbnailElement) {
              thumbnailSlider = new Flickity('[js-product-thumbnail-slider]', {
                contain: true,
                prevNextButtons: false,
                wrapAround: false,
                pageDots: false,
                cellAlign: 'left',
                draggable: false,
                asNavFor: '[js-product-main-slider]' // Link to main slider
              });
            }

            mainSlider.on('select', function(index) {
              const slideIndex = index || 0;
              
              const productMeasurementInfoWrapperList = document.querySelectorAll('[js-product-measurement-info-wrapper]');
              if (index === 2) {
                productMeasurementInfoWrapperList.forEach(element => {
                  element.classList.add('d-none');
                });
              } else {
                productMeasurementInfoWrapperList.forEach(element => {
                  element.classList.remove('d-none');
                });
              }

              const selectedSlide = mainSlider.selectedElement;
            if (selectedSlide && selectedSlide.hasAttribute('data-inspiration-image-id')) {
              productMeasurementInfoWrapperList.forEach(element => {
                element.classList.add('d-none');
              });
              document.querySelectorAll(`[js-product-inspiration-review-wrapper]`).forEach(element => {
                if (element.getAttribute('data-id') === selectedSlide.getAttribute('data-inspiration-image-id')) {
                  element.classList.add('active');
                } else {
                  element.classList.remove('active');
                }
              });
            } else {
              document.querySelectorAll(`[js-product-inspiration-review-wrapper]`).forEach(element => {
                element.classList.remove('active');
              });
            }
              
              // Only update thumbnail slider if it's not already at this index to prevent infinite loop
              if (thumbnailSlider && thumbnailSlider.selectedIndex !== index) {
                thumbnailSlider.select(index);
              }
              
              const mediaDescriptionWrap = document.querySelector("[js-product-media-description-wrap]");
              const mediaDescriptionEls = document.querySelectorAll("[js-product-media-description]");
              if (index > 0) {
                mediaDescriptionWrap?.classList.add("active");
              } else {
                mediaDescriptionWrap?.classList.remove("active");
              }
              mediaDescriptionEls?.forEach((item) => {
                if (slideIndex === parseInt(item.getAttribute('data-index'))) {
                  item.classList.add('active');
                } else {
                  item.classList.remove('active');
                }
              });
            });

            if (thumbnailSlider) {
              thumbnailSlider.on('select', function(index) {
                // Only update main slider if it's not already at this index to prevent infinite loop
                if (mainSlider.selectedIndex !== index) {
                  mainSlider.select(index);
                }
              });
              
              thumbnailSlider.cells.forEach((slide, index) => {
                slide.element.addEventListener("click", function() {
                  mainSlider.select(index);
                });
              });

              thumbnailSlider.on('ready', () => {
                initializeAllAnimations(thumbnailElement);
                
                // Ensure proper positioning after reinitialization
                setTimeout(() => {
                  // Force layout recalculation
                  thumbnailSlider.resize();
                  
                  // Set initial position without triggering events
                  thumbnailSlider.select(0, false, false);
                  mainSlider.select(0, false, false);
                  
                  // Manually trigger media description updates
                  const mediaDescriptionWrap = document.querySelector("[js-product-media-description-wrap]");
                  const mediaDescriptionEls = document.querySelectorAll("[js-product-media-description]");
                  if (mediaDescriptionWrap) {
                    mediaDescriptionWrap.classList.remove("active");
                  }
                  mediaDescriptionEls?.forEach((item) => {
                    if (parseInt(item.getAttribute('data-index')) === 0) {
                      item.classList.add('active');
                    } else {
                      item.classList.remove('active');
                    }
                  });
                  
                  // Force another resize to ensure proper layout
                  setTimeout(() => {
                    thumbnailSlider.resize();
                    mainSlider.resize();
                  }, 100);
                }, 100);
              });
            }
            
            window.productGallerySlider = mainSlider;
            
            const productTitle = document.querySelector(".product__title");
            if (productTitle) {
              const newProductTitle = productTitle.cloneNode(true);
              productTitle.parentNode.replaceChild(newProductTitle, productTitle);
              
              newProductTitle.addEventListener("click", function() {
                mainSlider.next();
              });
            }
          }).catch(e => {
            console.log('Error initializing Flickity:', e);
          });
        } else {
          setTimeout(() => {
            if (window.Flickity) {
              const mainSlider = new window.Flickity('[js-product-main-slider]', {
                contain: true,
                adaptiveHeight: true,
                prevNextButtons: true,
                wrapAround: false,
                pageDots: false,
                cellAlign: 'left'
              });
              
              const thumbnailElement = document.querySelector("[js-product-thumbnail-slider]");
              if (thumbnailElement) {
                const thumbnailSlider = new window.Flickity('[js-product-thumbnail-slider]', {
                  contain: true,
                  prevNextButtons: false,
                  wrapAround: false,
                  pageDots: false,
                  cellAlign: 'left',
                  draggable: false
                });
                
                thumbnailSlider.on('ready', () => {
                  window.productThumbnailSlider = thumbnailSlider;
                  initializeAllAnimations(thumbnailElement);
                  
                  // Ensure proper positioning after reinitialization
                  setTimeout(() => {
                    // Force layout recalculation
                    thumbnailSlider.resize();
                    
                    // Set initial position without triggering events
                    thumbnailSlider.select(0, false, false);
                    mainSlider.select(0, false, false);
                    
                    // Manually trigger media description updates
                    const mediaDescriptionWrap = document.querySelector("[js-product-media-description-wrap]");
                    const mediaDescriptionEls = document.querySelectorAll("[js-product-media-description]");
                    if (mediaDescriptionWrap) {
                      mediaDescriptionWrap.classList.remove("active");
                    }
                    mediaDescriptionEls?.forEach((item, i) => {
                      if (parseInt(item.getAttribute('data-index')) === 0) {
                        item.classList.add('active');
                      } else {
                        item.classList.remove('active');
                      }
                    });
                    
                    // Force another resize to ensure proper layout
                    setTimeout(() => {
                      thumbnailSlider.resize();
                      mainSlider.resize();
                    }, 100);
                  }, 100);
                });

                window.productThumbnailSlider = thumbnailSlider;
              }
              
              window.productGallerySlider = mainSlider;
            }
          }, 100);
        }
      }

      if (window.theme && window.theme.Product) {
        try {
          window.theme.Product.init();
        } catch (e) {
          console.log('Theme Product init failed:', e);
        }
      }
      
      document.dispatchEvent(new CustomEvent('gallery:reinit'));

      // Reload product section so ProductForm bindings are restored (theme uses Sections API)
      try {
        reinitProductSection();
      } catch (e) {
        console.log('Product section reload failed:', e);
      }

      window.ProductMainSliderApp.init();
    };

    var updateProductInfo = async (productUrl) => {
      try {
        window.location.href = productUrl;
      } catch (error) {
        console.error('Error updating product info:', error);
        // Fallback to regular page redirect if something goes wrong
        window.location.href = productUrl;
      } finally {
        // Remove loading state
        const container = document.querySelector('.product__size-picker');
        if (container) container.classList.remove('size-picker-loading');
      }
    };

    var calculateScrollProgress = (container, dragging = false, initialize = false) => {
      if (!container) return;
      const activeImage = container.querySelector('[js-image].active');
      const scrollBar = container.querySelector('[js-scroll-bar]');
      const imageList = container.querySelector('[js-image-list]');
      if (!scrollBar || !imageList || !activeImage) return;
      imageList.scrollTo(activeImage.getBoundingClientRect().left - imageList.getBoundingClientRect().left + imageList.scrollLeft - (imageList.clientWidth - activeImage.clientWidth) / 2, 0);
      if (!dragging) {
        setTimeout(() => {
          scrollBar.style.setProperty('--progress', activeImage.getBoundingClientRect().left - imageList.getBoundingClientRect().left + activeImage.offsetWidth / 2 + 'px');
        }, 150);
        if (!initialize) {
          setTimeout(() => {
            const productUrl = activeImage.getAttribute('data-href');
            if (productUrl) {
              updateProductInfo(productUrl);
            }
          }, 300);
        }
      }
    }
    
    var moveScrollBar = (container, percent, dragging = false) => {
      if (!container) return;
      const totalIndex = parseInt(container.getAttribute('data-total-index')) - 1;
      const unitPercent = 100 / totalIndex;
      let index = 0;
      if (percent <= unitPercent / 2) {
        index = 0;
      } else if (percent > (100 - unitPercent / 2)) {
        index = totalIndex;
      } else {
        for (let i = 1; i <= totalIndex - 1; i++) {
          if (percent > (unitPercent / 2 + unitPercent * (i - 1)) && percent <= (unitPercent / 2 + unitPercent * i)) {
            index = i;
          }
        }
      }
      setCurrentImage(container, container.querySelector(`[js-image][data-index="${index}"]`), dragging);
    }
    
    var setCurrentImage = (container, image, dragging = false) => {
      if (!container || !image) return;
      container.querySelectorAll('[js-image]').forEach(element => {
        element.classList.remove('active');
      });
      image.classList.add('active');
      calculateScrollProgress(container, dragging);
    }
    
    var startDragScroll = (container) => {
      if (!container) return;
      container.classList.add('dragging');
    }
    
    var dragScroll = (container, x) => {
      if (!container || !container.classList.contains('dragging')) return;
      const scrollBar = container.querySelector('[js-scroll-bar]');
      if (!scrollBar) return;
      scrollBar.style.setProperty('--transition', '0s');
      let progressValue = x - scrollBar.getBoundingClientRect().left;
      progressValue = (progressValue<0)?0:progressValue;
      progressValue = (progressValue>scrollBar.clientWidth)?(scrollBar.clientWidth):progressValue;
      scrollBar.style.setProperty('--progress', progressValue + 'px');
      moveScrollBar(container, progressValue*100/scrollBar.clientWidth, true);
    }
    
    var endDragScroll = (container) => {
      if (!container || !container.classList.contains('dragging')) return;
      container.classList.remove('dragging');
      const scrollBar = container.querySelector('[js-scroll-bar]');
      if (!scrollBar) return;
      scrollBar.style.setProperty('--transition', '0.3s');
      calculateScrollProgress(container);
    }
    
    var initEachSlider = (container) => {
      if (!container) return;
      const imageList = container.querySelector('[js-image-list]');
      if (imageList && imageList.scrollWidth == imageList.clientWidth) {
        imageList.style.justifyContent = 'space-around';
      }
      calculateScrollProgress(container, false, true);
      container.querySelectorAll('[js-image]').forEach(element => {
        element.addEventListener('click', () => {
          setCurrentImage(container, element);
        });
      });
      const scrollBar = container.querySelector('[js-scroll-bar]');
      if (!scrollBar) return;
      scrollBar.addEventListener('click', (event) => {
        moveScrollBar(container, (event.clientX - scrollBar.getBoundingClientRect().left) * 100 / scrollBar.clientWidth);
      });
      const scrollHandler = container.querySelector('[js-scroll-handler]');
      if (!scrollHandler) return;
      scrollHandler.addEventListener('mousedown', () => {
        startDragScroll(container);
      });
      document.addEventListener('mousemove', (event) => {
        dragScroll(container, event.clientX);
      });
      document.addEventListener('mouseup', () => {
        endDragScroll(container);
      });
      scrollHandler.addEventListener('touchstart', () => {
        startDragScroll(container);
      });
      document.addEventListener('touchmove', (event) => {
        dragScroll(container, event.touches[0].clientX);
      });
      document.addEventListener('touchend', () => {
        endDragScroll(container);
      });
    }
    
    var initialize = () => {
      document.querySelectorAll('[js-pdp-size-picker]').forEach(container => {
        initEachSlider(container);
      });
    }
    
    return {
      init: initialize
    }
  })();

  var ThresholdSystemApp = (() => {
    var isAddedGiftProduct = (cart, variant_id) => {
      let result = false;
      Array.from(cart.items).forEach(item => {
        if (item.variant_id == variant_id && item.properties['_is_free_gift'] === 'true') {
          result = true;
        }
      });
      return result;
    }
    var addGiftProduct = async (variant_id, required_product_id_list, required_product_count) => {
      const cart = await window.cart.get();
      if (isAddedGiftProduct(cart, variant_id)) {
        return;
      }
      if (required_product_count > 0) {
        window.cart.addItemById(variant_id, 1, {'_is_free_gift': 'true', '_required_product_id_list': required_product_id_list, '_required_product_count': required_product_count});
      }
    }
    var getPresentmentCents = (container, attributeName, shopAttributeName) => {
      const presentmentValue = parseInt(container.getAttribute(attributeName), 10);
      if (!Number.isNaN(presentmentValue) && presentmentValue > 0) {
        return presentmentValue;
      }
      const shopCents = parseInt(container.getAttribute(shopAttributeName), 10);
      if (Number.isNaN(shopCents)) return 0;
      if (window.Shopify?.currency?.rate && window.theme?.shopCurrency && window.Shopify.currency.active !== window.theme.shopCurrency) {
        return Math.round(shopCents * window.Shopify.currency.rate);
      }
      return shopCents;
    }
    var updateThreshold = (container, cart) => {
      if (!container || !cart) return;
      let product_from_collection_count = 0;
      let current_step = 0;
      const product_id_list = String(container.getAttribute('data-threshold-product-id-list-for-gift')).split(',');
      Array.from(cart.items).forEach(item => {
        current_step = 1;
        if (product_id_list.includes(String(item.variant_id))) {
          product_from_collection_count+=item.quantity;
        }
      });
      if (product_from_collection_count >= parseInt(container.getAttribute('data-threshold-collection-product-count'))) {
        current_step = 2;
      }
      container.querySelectorAll('[is-free-gift]').forEach(element => {
        element.classList.remove('is-adding');
      });
      let progress = product_from_collection_count * 100 / parseInt(container.getAttribute('data-threshold-collection-product-count'));
      progress = (progress > 100) ? 100 : progress;

      const shippingLabel = document.querySelector('.quick-cart .shipping-price');

      let shippingThreshold = 0;
      let shippingValue = 0;
      let shippingProgress = 100;
      shippingThreshold = getPresentmentCents(container, 'data-shipping-threshold', 'data-shipping-threshold-shop');
      shippingValue = getPresentmentCents(container, 'data-shipping-value', 'data-shipping-value-shop');
      const free_shipping_product_id_list = String(container.getAttribute('data-free-shipping-product-id-list')).trim().split(',');
      let free_shipping = true;
      Array.from(cart.items).forEach(item => {
        if (!free_shipping_product_id_list.includes(String(item.product_id))) free_shipping = false;
      });
      if (cart.total_price <= shippingThreshold && free_shipping === false) {
        current_step = 0;
        progress = 0;
        shippingProgress = cart.total_price * 100 / shippingThreshold;
        if (shippingLabel) {
          shippingLabel.innerHTML = window.formatMoney(shippingValue);
        }
      } else if (shippingLabel) {
        shippingLabel.innerHTML = shippingLabel.getAttribute('data-free-shipping-text');
      }

      if (container.querySelector('[data-shipping-template]')) {
        container.querySelector('[data-shipping-template]').innerHTML = String(container.querySelector('[data-shipping-template]').getAttribute('data-shipping-template')).replace('((value))', window.formatMoney(shippingThreshold - cart.total_price));
      }

      if (current_step > 0) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            attributes: {
              _free_shipping_flag: 'true',
            },
          }),
        });
      } else {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            attributes: {
              _free_shipping_flag: null,
            },
          }),
        });
      }

      container.style.setProperty('--progress', progress + '%');
      container.style.setProperty('--shipping-progress', shippingProgress + '%');
      container.setAttribute('data-step', current_step);
      let successFlag = false;
      if (current_step == 2) {
        successFlag = true;
      }
      container.querySelectorAll('[is-free-gift]').forEach(element => {
        element.classList.remove('d-none');
        if (isAddedGiftProduct(cart, element.getAttribute('is-free-gift'))) {
          element.classList.add('d-none');
        } else {
          successFlag = false;
        }
      });
      if (successFlag == true) {
        container.setAttribute('data-step', 'success');
      }
    }
    var initEachContainer = (container) => {
      if (!container) {
        return;
      }
      if (parseInt(container.getAttribute('data-step')) == 2) {
        let successFlag = true;
        container.querySelectorAll('[is-free-gift]').forEach(element => {
          if (!element.classList.contains('d-none')) successFlag = false;
        });
        if (successFlag) {
          container.setAttribute('data-step', 'success');
        }
      }
      document.addEventListener('threshold-system:product-id-list-for-gift:updated', () => {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            updateThreshold(container, cart);
          })
          .catch(error => console.error('Error:', error));
      });
      document.addEventListener('cart:updated', (event) => {
        console.log('Cart: ', event.detail.cart);
        updateThreshold(container, event.detail.cart);
      });
      container.querySelectorAll('[is-free-gift] [js-atc]').forEach(element => {
        element.addEventListener('click', () => {
          const wrapper = element.closest('[is-free-gift]');
          if (wrapper.classList.contains('is-adding')) return;
          wrapper.classList.add('is-adding');
          addGiftProduct(wrapper.getAttribute('is-free-gift'), container.getAttribute('data-threshold-product-id-list-for-gift'), parseInt(container.getAttribute('data-threshold-collection-product-count')));
        });
      });
    }
    var initialize = () => {
      document.querySelectorAll('[js-threshold-system]').forEach(container => {
        initEachContainer(container);
      });
    }
    return {
      init: initialize
    }
  })();

  var CollectionFilterTabApp = (() => {
    // Picks the slide matching the clicked tab's role (product/home/dimension).
    // Cards don't always have all 3 roles (e.g. a 2-image product card has no
    // "dimension" slide), so each role falls back through the roles that would
    // hold progressively earlier images - this lands on the last real image
    // the card actually has, not just the last slide in the DOM (the "-b" markup
    // reorders slides, so "last DOM slide" isn't always "last real image").
    var ROLE_FALLBACK_CHAIN = {
      dimension: ['dimension', 'home', 'product'],
      home: ['home', 'product'],
      product: ['product']
    };
    var getSlideIndexForRole = (slides, role) => {
      if (!slides.length) return -1;
      const chain = ROLE_FALLBACK_CHAIN[role] || [role];
      for (let c = 0; c < chain.length; c++) {
        for (let i = 0; i < slides.length; i++) {
          const slideRoles = (slides[i].getAttribute('data-slide-role') || '').split(' ');
          if (slideRoles.indexOf(chain[c]) !== -1) {
            return i;
          }
        }
      }
      return slides.length - 1;
    }
    var filter = (trigger_id, container, role) => {
      if (!trigger_id || trigger_id === '' || !container) return;
      container.querySelectorAll('[js-trigger]').forEach(element => {
        if (element.getAttribute('js-trigger') === String(trigger_id)) {
          element.classList.add('active');
        } else {
          element.classList.remove('active');
        }
      });
      window.mediaFlickityInstances.forEach(flkty => {
        const slides = flkty.element.querySelectorAll('.media-slide');
        const index = getSlideIndexForRole(slides, role);
        if (index !== -1) flkty.select(index);
      });
      window.collectionSliderMediaFlickityInstances.forEach(flkty => {
        const slides = flkty.element.querySelectorAll('.media-slide');
        const index = getSlideIndexForRole(slides, role);
        if (index !== -1) flkty.select(index);
      });
      container.setAttribute('data-current-trigger-id', trigger_id);
      container.setAttribute('data-current-tab-role', role || '');

      document.querySelectorAll('.slider-product-item .media-slider-wrapper').forEach(element => {
        const slides = element.querySelectorAll('.media-slide');
        const index = getSlideIndexForRole(slides, role);
        if (index === -1) return;
        element.scrollTo(element.clientWidth * index, 0);
        element.querySelectorAll('.media-slider-image-dots [data-id]').forEach(dot => {
          dot.classList.remove('active');
          if (parseInt(dot.getAttribute('data-id'), 10) === index) {
            dot.classList.add('active');
          }
        });
      });
    }
    var setFilterTabVisibility = () => {
      let flag = false;
      document.querySelectorAll('.bd-product-list-slider').forEach(element => {
        if (element.getBoundingClientRect().top < window.innerHeight && element.getBoundingClientRect().top + element.getBoundingClientRect().height > window.innerHeight / 2) {
          flag = true;
        }
      });
      document.querySelectorAll('.collection-filter--wrapper').forEach(element => {
        if (flag) {
          element.classList.remove('disabled');
        } else {
          element.classList.add('disabled');
        }
      });
    }
    var initialize = () => {
      let firstView = true;
      const targetElement = document.querySelector('.collection__products .product-item'); 

      if (!targetElement) return;

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && firstView) {
            firstView = false;
            setTimeout(() => {
              const firstMediaWrapper = window.mediaFlickityInstances[0];
              if (firstMediaWrapper) {
                firstMediaWrapper.select(1);
                setTimeout(() => {
                  firstMediaWrapper.select(0);
                }, 500);
              }
              const firstCollectionSliderMediaWrapper = window.collectionSliderMediaFlickityInstances[0];
              if (firstCollectionSliderMediaWrapper) {
                firstCollectionSliderMediaWrapper.select(1);
                setTimeout(() => {
                  firstCollectionSliderMediaWrapper.select(0);
                }, 500);
              }
            }, 1000);
          }
        });
      });
      observer.observe(targetElement);
      
      document.querySelectorAll('[js-collection-filter] [js-trigger]').forEach(element => {
        element.addEventListener('click', () => {
          filter(element.getAttribute('js-trigger'), element.closest('[js-collection-filter]'), element.getAttribute('data-tab-role'));
        });
      });

      if (document.body.hasAttribute('collection-page-redesign-ab-test')) {
        window.addEventListener('scroll', () => {
          setFilterTabVisibility();
        });
      }
    }
    return {
      init: initialize
    }
  })();

  var BDProductListSliderApp = (() => {
    var renderSlides = () => {
      document.querySelectorAll('[js-bd-product-list-slider]').forEach(slider => {
        if (slider.getBoundingClientRect().y <= window.innerHeight + 1000 && slider.getBoundingClientRect().y >= -1 * (slider.getBoundingClientRect().height - 1000) || true) {
          // var flkty = new Flickity( slider, {
          //   draggable: true,
          //   pageDots: false,
          //   prevNextButtons: true,
          //   cellAlign: "center",
          //   adaptiveHeight: false,
          //   contain: true,
          //   resize: true,
          //   wrapAround: true
          // });
        }
      });
    }
    var initialize = () => {
      renderSlides();
      window.addEventListener('scroll', () => {
        renderSlides();
      })
    }
    return {
      init: initialize
    }
  })()
  var PDPDividedPriceApp = (() => {
    var initialize = () => {
      document.addEventListener("product:variant-change", function (evt) {
        document.querySelectorAll('[js-divided-price]').forEach(element => {
          if (String(element.getAttribute('data-variant-id')) === String(evt.detail.variant.id)) {
            element.classList.add('active');
          } else {
            element.classList.remove('active');
          }
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var CartDrawerUpsellApp = (() => {
    var isFinishedThreshold = () => {
      const thresholdSystem = document.querySelector('[js-threshold-system]');
      if (!thresholdSystem) return false;
      const current_step = thresholdSystem.getAttribute('data-step');
      if (!thresholdSystem.querySelector('.progress-bar__icon[data-step]:last-of-type')) return;
      const final_step = thresholdSystem.querySelector('.progress-bar__icon[data-step]:last-of-type').getAttribute('data-step');
      if (current_step === final_step) return true;
    }
    var findVariantByOptions = (variants, selectedOptions) => {
      return variants.find(variant => {
        return selectedOptions.every((value, index) => {
          const optionKey = `option${index + 1}`;
          return variant[optionKey] === value;
        });
      });
    }
    var getSelectedVariant = (upsellProduct) => {
      if (!upsellProduct) return;
      const variantDataScript = upsellProduct.querySelector('[data-product-variants]');
      if (!variantDataScript) return null;

      const productData = JSON.parse(variantDataScript.textContent);
      const selects = upsellProduct.querySelectorAll('select');
      
      const selectedOptions = Array.from(selects).map(select => select.value);
      
      return findVariantByOptions(productData.variants, selectedOptions);
    }
    var renderUpsellWrapper = () => {
      fetch('/?section_id=header')
      .then(response => response.text())
      .then(html => {
        const upsellWrapper = new DOMParser().parseFromString(html, 'text/html').querySelector('.quick-cart [data-items]+[js-quick-cart-upsell-product-list]');
        const upsell_wrapper_html = upsellWrapper ? upsellWrapper.outerHTML : '';
        const cartItemsWrapper = document.querySelector('.quick-cart [data-items]');
        if (cartItemsWrapper) {
          if (cartItemsWrapper.querySelector('[js-quick-cart-upsell-product-list]')) {
            cartItemsWrapper.querySelector('[js-quick-cart-upsell-product-list]').outerHTML = upsell_wrapper_html;
          } else {
            cartItemsWrapper.innerHTML += upsell_wrapper_html;
          }
          const upsellListSlider = cartItemsWrapper.querySelector('[js-quick-cart-upsell-product-list] .heading+div');
          if (upsellListSlider) {
            upsellListSlider.closest('[js-quick-cart-upsell-product-list]').classList.remove('d-none');
            const f = new Flickity(upsellListSlider, {
              cellAlign: "left",
              contain: true,
              pageDots: false,
              prevNextButtons: false
            });
            if (isFinishedThreshold() === true) upsellListSlider.closest('[js-quick-cart-upsell-product-list]').classList.add('d-none');
            upsellListSlider.querySelectorAll('.upsell-product .variant-option select').forEach(element => {
              element.addEventListener('change', () => {
                const customSelect = element.closest('.variant-option').querySelector('.custom-select [data-option-name]');
                if (customSelect) {
                  customSelect.innerHTML  = `${customSelect.getAttribute('data-option-name')}: ${element.value}`;
                }
                const variant = getSelectedVariant(element.closest('.upsell-product'));
                if (variant) {
                  element.closest('.upsell-product').querySelectorAll('.price').forEach(price => {
                    price.classList.remove('active');
                    if (price.getAttribute('data-variant-id') === String(variant.id)) {
                      price.classList.add('active');
                    }
                  });
                }
              });
            });
            upsellListSlider.querySelectorAll('.upsell-product [js-add]').forEach(element => {
              element.addEventListener('click', () => {
                const variant = getSelectedVariant(element.closest('.upsell-product'));
                if (variant) {
                  element.closest('.upsell-product').classList.add('loading'); 
                  window.cart.addItemById(variant.id, 1);
                }
              });
            });
          }
        }
      })
      .catch(error => {
        console.error('Error fetching cart drawer section:', error);
      });
    }
    var initialize = () => {
      renderUpsellWrapper();
      document.addEventListener('cart:updated', (event) => {
        renderUpsellWrapper();
      });

      function handleUpsellAppear(element) {
        console.log('Upsell product list appeared in viewport!');
        window.dispatchEvent(new Event('resize'));
      }

      const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            handleUpsellAppear(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px'
      });

      function observeUpsellList() {
        const upsellElement = document.querySelector('[js-quick-cart-upsell-product-list] .heading+div');
        
        if (upsellElement) {
          intersectionObserver.observe(upsellElement);
        }
      }

      const mutationObserver = new MutationObserver((mutations) => {
        mutations.forEach(() => {
          observeUpsellList();
        });
      });

      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
      });

      observeUpsellList();
    }
    return {
      init: initialize
    }
  })();

  var BundleVariantOptionApp = (() => {
    var addInputsToProductForm = (variant_id, bundle_info) => {
      if (!bundle_info || !variant_id) return;
      const productFormElement = document.querySelector('[js-main-product] [data-product-form]');
      if (productFormElement) {
        const quantityInputElement = productFormElement.querySelector('input[name="quantity"]');
        if (quantityInputElement) {
          quantityInputElement.value = 0;
        }
        productFormElement.querySelectorAll('[js-variant-bundle-input]').forEach(element => {
          element.remove();
        });
        let bundleId = `bundle-${variant_id}-children-`;
        let bundleRecipe = '{';
        Array.from(bundle_info.children_variant).forEach((variant_info, index) => {
          bundleId += `${variant_info.quantity}_${variant_info.variant.id}_`;
          bundleRecipe += `&quot;gid://shopify/ProductVariant/${variant_info.variant.id}&quot;:${variant_info.quantity}`;
          if (index < Array.from(bundle_info.children_variant).length - 1) {
            bundleRecipe += ',';
          }
        });
        bundleRecipe += '}';
        console.log('Here is bundleRecipe', bundleRecipe);
        const new_input_elements_html = Array.from(bundle_info.children_variant).map((variant_info, index) => {
          return `
            <input js-variant-bundle-input type="hidden" name="items[${index}][id]" value="${variant_info.variant.id}">
            <input js-variant-bundle-input type="hidden" name="items[${index}][quantity]" value="${variant_info.quantity}">
            <input js-variant-bundle-input type="hidden" name="items[${index}][properties][_bundle_id]" value="${bundleId}">
            <input js-variant-bundle-input type="hidden" name="items[${index}][properties][_bundle_parent_variant]" value="${variant_id}">
            <input js-variant-bundle-input type="hidden" name="items[${index}][properties][_bundle_recipe]" value="${bundleRecipe}">
            <input js-variant-bundle-input type="hidden" name="items[${index}][properties][_bundle_parent_price]" value="${bundle_info.price / 100.0}">
            <input js-variant-bundle-input type="hidden" name="items[${index}][properties][_bundle_role]" value="child">
            <input js-variant-bundle-input type="hidden" name="items[${index}][properties][_bundle_index]" value="${index}">
          `;
        }).join("");
        productFormElement.insertAdjacentHTML("beforeend", new_input_elements_html);

        const mainProductSection = document.querySelector("[js-main-product]")
        const fetchUrl = `${location.origin}${location.pathname}?variant=${variant_id}&section_id=${mainProductSection.dataset.sectionId}`

        const buyButton = productFormElement.querySelector('button[type=submit]');
        if (buyButton) {
          buyButton.classList.add('disabled');
        }
        fetch(fetchUrl)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newDeliveryInputName = doc.querySelector('[js-delivery-text-input-name]');
            const newDeliveryInputDays = doc.querySelector('[js-delivery-text-input-days]');
            const newDeliveryInputFirstDays = doc.querySelector('[js-delivery-text-input-first-days]');
            const newDeliveryInputIsPreorder = doc.querySelector('[js-delivery-text-input-is-preorder]');
            if (newDeliveryInputName && newDeliveryInputDays) {
              const firstDaysValue = newDeliveryInputFirstDays ? newDeliveryInputFirstDays.value : newDeliveryInputDays.value;
              const isPreorderValue = newDeliveryInputIsPreorder ? newDeliveryInputIsPreorder.value : 'false';
              let new_attribute_elements_html = Array.from(bundle_info.children_variant).map((variant_info, index) => {
                return `
                  <input js-variant-bundle-input type="hidden" name="items[${index}][properties][_delivery_date_label]" value="${newDeliveryInputName.value}">
                  <input js-variant-bundle-input type="hidden" name="items[${index}][properties][_delivery_days]" value="${newDeliveryInputDays.value}">
                  <input js-variant-bundle-input type="hidden" name="items[${index}][properties][_delivery_days_first]" value="${firstDaysValue}">
                  <input js-variant-bundle-input type="hidden" name="items[${index}][properties][_is_preorder]" value="${isPreorderValue}">
                `;
              }).join("");
              new_attribute_elements_html += `
                <input js-variant-bundle-input type="hidden" name="properties[_delivery_date_label]" value="${newDeliveryInputName.value}">
                <input js-variant-bundle-input type="hidden" name="properties[_delivery_days]" value="${newDeliveryInputDays.value}">
                <input js-variant-bundle-input type="hidden" name="properties[_delivery_days_first]" value="${firstDaysValue}">
                <input js-variant-bundle-input type="hidden" name="properties[_is_preorder]" value="${isPreorderValue}">
              `;
              productFormElement.insertAdjacentHTML("beforeend", new_attribute_elements_html);
              if (buyButton) {
                buyButton.classList.remove('disabled');
              }
            }
          });
      }
    }
    var removeInputsFromProductForm = () => {
      document.querySelectorAll('[js-main-product] [data-product-form] [js-variant-bundle-input]').forEach(element => {
        element.remove();
      });
      const quantityInputElement = document.querySelector('[js-main-product] [data-product-form] input[name="quantity"]');
      if (quantityInputElement) {
        quantityInputElement.value = 1;
      }
    }
    var initialize = () => {
      document.addEventListener('DOMContentLoaded', () => {
        if (document.querySelector('[data-current-variant-id]')) {
          const variant_id = document.querySelector('[data-current-variant-id]').getAttribute('data-current-variant-id');
          let normal_variant_flag = true;
          if (typeof BUNDLE_VARIANT_INFO !== 'undefined' && BUNDLE_VARIANT_INFO[variant_id]) {
            addInputsToProductForm(variant_id, BUNDLE_VARIANT_INFO[variant_id]);
            normal_variant_flag = false;
          }
          if (normal_variant_flag === true) {
            removeInputsFromProductForm();
          }
        }
      });
      document.addEventListener('product:variant-change', (event) => {
        const variant_id = event.detail.variant.id;
        let normal_variant_flag = true;
        if (typeof BUNDLE_VARIANT_INFO !== 'undefined' && BUNDLE_VARIANT_INFO[variant_id]) {
          addInputsToProductForm(variant_id, BUNDLE_VARIANT_INFO[variant_id]);
          normal_variant_flag = false;
        }
        if (normal_variant_flag === true) {
          removeInputsFromProductForm();
        }
      });
    }
    return {
      init: initialize
    }
  })();

  var OrderDeliveryDateApp = (() => {
    var addCartAttribute = async (newAttributes) => {
      try {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();

        const mergedAttributes = {
          ...(cart.attributes || {}),
          ...newAttributes
        };

        const updateRes = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: mergedAttributes
          })
        });

        const updatedCart = await updateRes.json();
        console.log('Updated cart:', updatedCart);
        return updatedCart;
      } catch (error) {
        console.error('Error updating cart attributes:', error);
      }
    }
    var getOrderDeliveryDateLabel = (items) => {
      if (!items) return;
      for (let i = 0; i < items.length; i++) {
        if (items[i].properties && items[i].properties['_delivery_date_label']) {
          return items[i].properties['_delivery_date_label'];
        }
      }
    }
    var getOrderDeliveryDays = (items) => {
      if (!items) return;
      let max_days = 0;
      for (let i = 0; i < items.length; i++) {
        if (items[i].properties && items[i].properties['_delivery_days']) {
          const days = parseInt(items[i].properties['_delivery_days']);
          if (days > max_days) {
            max_days = days;
          }
        }
      }
      return max_days;
    }
    var setOrderDeliveryDate = (items) => {
      if (!items) return;
      const delivery_date_label = getOrderDeliveryDateLabel(items);
      const delivery_days = getOrderDeliveryDays(items);
      if (!delivery_date_label || !delivery_days) return;
      const delivery_date = {
        _delivery_date_label: delivery_date_label,
        _delivery_days: delivery_days
      };
      delivery_date['Delivery days'] = delivery_days;
      addCartAttribute(delivery_date);
    }
    var initialize = () => {
      document.addEventListener('cart:updated', (event) => {
        setOrderDeliveryDate(event.detail.cart.items);
      });
    }
    return {
      init: initialize
    }
  })();

  var BDCollectionPageProductFilterApp = (() => {
    const flickityBySlider = new WeakMap();
    const rackFlickityBySlider = new WeakMap();
    const VERSION_CELL_SELECTOR = '.pf-option-item--version:not(.is-filtered-out)';
    var visibilityObserverBound = false;

    function isPfSectionVisible() {
      var section = document.querySelector('.bd-collection-page-product-filter');
      if (!section) return false;
      return section.getClientRects().length > 0;
    }

    function shouldRunPfInit() {
      return document.querySelector('.bd-collection-page-product-filter') && isPfSectionVisible();
    }

    var initOptionSlider = (slider, cellSelector) => {
      if (!slider) return null;
      if (flickityBySlider.has(slider)) {
        flickityBySlider.get(slider).destroy();
      }
      const flkty = new Flickity(slider, {
        prevNextButtons: false,
        adaptiveHeight: false,
        wrapAround: false,
        pageDots: false,
        contain: true,
        imagesLoaded: true,
        cellAlign: 'left',
        cellSelector: cellSelector
      });
      flickityBySlider.set(slider, flkty);
      return flkty;
    };

    var initRackSlider = (slider) => {
      if (!slider) return;
      if (rackFlickityBySlider.has(slider)) {
        rackFlickityBySlider.get(slider).destroy();
        rackFlickityBySlider.delete(slider);
      }
      const flkty = new Flickity(slider, {
        prevNextButtons: false,
        adaptiveHeight: false,
        wrapAround: false,
        pageDots: false,
        contain: true,
        imagesLoaded: true,
        cellAlign: 'left'
      });
      rackFlickityBySlider.set(slider, flkty);
      return flkty;
    };

    var initVersionSliders = (familieEl) => {
      if (!familieEl) return;
      familieEl.querySelectorAll('.pf-option-row--versions[js-collection-page-option-slider]').forEach(function (slider) {
        initOptionSlider(slider, VERSION_CELL_SELECTOR);
      });
      familieEl.querySelectorAll('[js-collection-page-rack-option-slider]').forEach(initRackSlider);
    };

    var resizeFamilieSliders = (familieEl) => {
      if (!familieEl) return;
      familieEl.querySelectorAll('.pf-option-row--versions[js-collection-page-option-slider]').forEach(function (slider) {
        const flkty = flickityBySlider.get(slider);
        if (flkty) flkty.resize();
      });
      familieEl.querySelectorAll('[js-collection-page-rack-option-slider]').forEach(function (slider) {
        const flkty = rackFlickityBySlider.get(slider);
        if (flkty) flkty.resize();
      });
    };

    var COLOR_MAP = {
      'schwarz':   '#312E28',
      'gold':      '#B7965B',
      'weiß':      '#FAFAFA',
      'weiss':     '#FAFAFA',
      'beige':     '#e8dcc8',
      'green':     '#4a7c59',
      'red':       '#c0392b',
      'silber':    '#c0c0c0',
      'anthrazit': '#4a4a4a'
    };
    var selectedColors = {};

    function initSwatchColors(scope) {
      var root = scope || document;
      root.querySelectorAll('.pf-swatch:not([data-pf-bound])').forEach(function (swatch) {
        var key = (swatch.dataset.color || '').toLowerCase();
        swatch.style.backgroundColor = COLOR_MAP[key] || '#ccc';
      });

      root.querySelectorAll('.pf-color-swatch:not([data-pf-bound])').forEach(function (swatch) {
        var key = (swatch.dataset.color || '').toLowerCase();
        swatch.style.backgroundColor = COLOR_MAP[key] || '#ccc';
      });
    }

    function swatchKey(el) {
      return (el.dataset.color || '').toLowerCase();
    }

    function versionItemKey(el) {
      return el.getAttribute('title') || '';
    }

    function parsePrice(text) {
      if (!text) return null;
      var match = String(text).match(/[\d,.]+/);
      if (!match) return null;
      return parseFloat(match[0].replace(',', '.'));
    }

    function mergeUniqueItems(targetRow, incomingRow, itemSelector, keyFn) {
      if (!targetRow || !incomingRow) return;
      var existingKeys = new Set(
        Array.from(targetRow.querySelectorAll(itemSelector)).map(keyFn)
      );
      incomingRow.querySelectorAll(itemSelector).forEach(function (item) {
        var key = keyFn(item);
        if (!key || existingKeys.has(key)) return;
        targetRow.appendChild(item.cloneNode(true));
        existingKeys.add(key);
      });
    }

    function mergeFamilieBlocks(existingEl, incomingEl) {
      if (!existingEl || !incomingEl) return;

      var existingPriceEl = existingEl.querySelector('.cpvp-info-price');
      var incomingPriceEl = incomingEl.querySelector('.cpvp-info-price');
      var existingPrice = parsePrice(existingPriceEl && existingPriceEl.textContent);
      var incomingPrice = parsePrice(incomingPriceEl && incomingPriceEl.textContent);
      if (existingPriceEl && incomingPrice != null &&
          (existingPrice == null || incomingPrice < existingPrice)) {
        existingPriceEl.textContent = incomingPriceEl.textContent;
      }

      var existingOptions = existingEl.querySelector('.pf-options');
      var incomingOptions = incomingEl.querySelector('.pf-options');
      if (!existingOptions || !incomingOptions) return;

      var existingColorsRow = existingOptions.querySelector('.pf-option-row.--colors');
      var incomingColorsRow = incomingOptions.querySelector('.pf-option-row.--colors');
      if (incomingColorsRow) {
        if (!existingColorsRow) {
          existingColorsRow = incomingColorsRow.cloneNode(true);
          existingOptions.insertBefore(existingColorsRow, existingOptions.firstChild);
        } else {
          mergeUniqueItems(existingColorsRow, incomingColorsRow, '.pf-swatch', swatchKey);
        }
      }

      var existingVersionsRow = existingOptions.querySelector('.pf-option-row--versions');
      var incomingVersionsRow = incomingOptions.querySelector('.pf-option-row--versions');
      if (incomingVersionsRow) {
        if (!existingVersionsRow) {
          existingVersionsRow = incomingVersionsRow.cloneNode(true);
          var shelfRow = existingOptions.querySelector('[js-collection-page-rack-option-slider]');
          if (shelfRow) {
            existingOptions.insertBefore(existingVersionsRow, shelfRow);
          } else {
            existingOptions.appendChild(existingVersionsRow);
          }
        } else {
          mergeUniqueItems(existingVersionsRow, incomingVersionsRow, '.pf-option-item--version', versionItemKey);
        }
      }
    }

    // ─── Color filter ─────────────────────────────────────────

    function applyColorFilter(familie, scope) {
      var root = scope || document;
      var selected = selectedColors[familie] || null;
      var familieEl = root.querySelector('.pf-familie[data-familie="' + familie + '"]') ||
        document.querySelector('.pf-familie[data-familie="' + familie + '"]');

      root.querySelectorAll('.pf-swatch[data-familie="' + familie + '"]').forEach(function (sw) {
        sw.classList.remove('is-active');
        if (selected && selected === sw.dataset.color) {
          sw.classList.add('is-active');
        }
      });

      root.querySelectorAll('.pf-option-item--version[data-familie="' + familie + '"]').forEach(function (item) {
        if (!selected) {
          item.classList.remove('is-filtered-out');
          item.style.display = '';
          return;
        }
        var hide = item.dataset.color !== selected;
        item.classList.toggle('is-filtered-out', hide);
        item.style.display = hide ? 'none' : '';
      });

      if (familieEl) {
        initVersionSliders(familieEl);
        resizeFamilieSliders(familieEl);
      }
    }

    function getPfSection(root) {
      if (root && root.closest) {
        return root.closest('.bd-collection-page-product-filter');
      }
      return document.querySelector('.bd-collection-page-product-filter');
    }

    function updateVersionLabelCount(familie, root, selectedColor) {
      var scope = root || document;
      var selector = '.pf-option-item--version[data-familie="' + familie + '"]';
      if (selectedColor) {
        selector += '[data-color="' + selectedColor + '"]';
      }
      var versionNum = scope.querySelectorAll(selector).length;
      var versionLabelTitleEle = scope.querySelector('.pf-version-label-title[data-familie="' + familie + '"]');
      if (!versionLabelTitleEle) return;

      var section = getPfSection(scope);
      var versionsLabel = section ? section.dataset.versionsLabel : '';
      var versionsLabelWithCount = section ? section.dataset.versionsLabelWithCount : '';

      if (versionNum > 1 && versionsLabelWithCount) {
        versionLabelTitleEle.textContent = versionsLabelWithCount.replace('{{ count }}', versionNum);
      } else if (versionsLabel) {
        versionLabelTitleEle.textContent = versionsLabel;
      }
    }

    function findBlackSwatch(familieEl) {
      if (!familieEl) return null;
      var swatches = familieEl.querySelectorAll('.pf-swatch[data-color]');
      for (var i = 0; i < swatches.length; i++) {
        var color = (swatches[i].dataset.color || '').toLowerCase().trim();
        if (color === 'schwarz' || color === 'black') return swatches[i];
      }
      return null;
    }

    function initSwatches(scope, options) {
      var root = scope || document;
      var autoClickFirst = !options || options.autoClickFirst !== false;

      root.querySelectorAll('.pf-swatch:not([data-pf-bound])').forEach(function (swatch) {
        swatch.setAttribute('data-pf-bound', 'true');
        swatch.addEventListener('click', function () {
          var url = swatch.dataset.url;
          if (url) window.location.href = url;
        });
      });

      if (autoClickFirst) {
        root.querySelectorAll('.pf-familie').forEach(function (family) {
          if (!family.querySelector('.pf-swatch[data-pf-bound]') || family.hasAttribute('data-pf-swatch-init')) return;
          family.setAttribute('data-pf-swatch-init', 'true');
          var familie = family.dataset.familie;
          var blackSwatch = findBlackSwatch(family);
          if (!blackSwatch || !familie) return;

          selectedColors[familie] = blackSwatch.dataset.color;
          applyColorFilter(familie, family);
          updateVersionLabelCount(familie, family, blackSwatch.dataset.color);
        });
      }
    }

    function initOptionItems(scope) {
      var root = scope || document;
      root.querySelectorAll('.pf-option-item:not([data-pf-bound])').forEach(function (item) {
        item.setAttribute('data-pf-bound', 'true');
        item.addEventListener('click', function () {
          if (item.dataset.url) window.location.href = item.dataset.url;
        });
      });
    }

    function initRackOptionItems(scope) {
      var root = scope || document;
      root.querySelectorAll('.pf-rack-option-item:not([data-pf-bound])').forEach(function (item) {
        item.setAttribute('data-pf-bound', 'true');
        item.addEventListener('click', function () {
          var mainUrl = item.dataset.mainUrl;
          if (!mainUrl) return;
          var variantId = item.dataset.upsellVariantId;
          var target = mainUrl;
          if (variantId) {
            var joiner = mainUrl.indexOf('?') >= 0 ? '&' : '?';
            target = mainUrl + joiner + 'upsell_variant=' + encodeURIComponent(variantId);
          }
          window.location.href = target;
        });
      });
    }

    function initFamilie(familieEl, options) {
      if (!familieEl) return;
      initSwatchColors(familieEl);
      initSwatches(familieEl, options);
      initOptionItems(familieEl);
      initRackOptionItems(familieEl);

      var familie = familieEl.dataset.familie;
      initVersionSliders(familieEl);
      if (selectedColors[familie]) {
        applyColorFilter(familie, familieEl);
        updateVersionLabelCount(familie, familieEl, selectedColors[familie]);
      } else {
        updateVersionLabelCount(familie, familieEl, null);
      }

      setTimeout(function () {
        resizeFamilieSliders(familieEl);
      }, 300);
    }

    var initialize = function (container) {
      var root = container || document;
      if (!shouldRunPfInit()) return;

      initSwatchColors(root);
      initSwatches(root);
      initOptionItems(root);
      initRackOptionItems(root);

      root.querySelectorAll('.pf-familie').forEach(function (familieEl) {
        initVersionSliders(familieEl);
      });

      setTimeout(function () {
        root.querySelectorAll('.pf-familie').forEach(function (familieEl) {
          resizeFamilieSliders(familieEl);
        });
      }, 300);
    };

    function setupVisibilityWatcher() {
      if (visibilityObserverBound) return;
      visibilityObserverBound = true;

      var scheduleInit = function () {
        requestAnimationFrame(function () {
          initialize(document);
        });
      };

      var observer = new MutationObserver(scheduleInit);
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['data-pm7-ab-collection']
      });

      window.addEventListener('load', scheduleInit);

      var section = document.querySelector('.bd-collection-page-product-filter');
      if (section && typeof ResizeObserver !== 'undefined') {
        var resizeObserver = new ResizeObserver(function () {
          if (isPfSectionVisible()) scheduleInit();
        });
        resizeObserver.observe(section);
      }
    }

    var initWhenVisible = function (container) {
      setupVisibilityWatcher();
      initialize(container || document);
    };

    return {
      init: initWhenVisible,
      mergeFamilieBlocks: mergeFamilieBlocks,
      initFamilie: initFamilie
    };
  })();

  let PFCollectionPageExtenderApp = (() => {
    let initialize = async () => {
      const sectionEl = document.querySelector('.bd-collection-page-product-filter')
      if (!sectionEl) return
      if (sectionEl.getClientRects().length === 0) return

      const collectionHandle = sectionEl.dataset.collectionHandle
      const sectionId = sectionEl.dataset.sectionId
      const hasNext = sectionEl.dataset.hasNext === 'true'

      if (!hasNext) return

      try {
        const res = await fetch(`/collections/${collectionHandle}?page=2&sections=${sectionId}`)
        if (!res.ok) throw new Error('[PFExtender] Fetch failed')
        const data = await res.json()

        const html = data[sectionId]
        if (!html) return

        const parsedDoc = new DOMParser().parseFromString(html, 'text/html')
        const newSection = parsedDoc.querySelector('.bd-collection-page-product-filter')
        if (!newSection) return

        const pfCollection = sectionEl.querySelector('#pf-collection')
        if (!pfCollection) return

        const existingByFamilie = {}
        sectionEl.querySelectorAll('.pf-familie[data-familie]').forEach(function (el) {
          existingByFamilie[el.dataset.familie] = el
        })

        newSection.querySelectorAll('.pf-familie[data-familie]').forEach(function (incomingFamilie) {
          const familieName = incomingFamilie.dataset.familie
          const existingFamilie = existingByFamilie[familieName]

          if (existingFamilie) {
            BDCollectionPageProductFilterApp.mergeFamilieBlocks(existingFamilie, incomingFamilie)
            BDCollectionPageProductFilterApp.initFamilie(existingFamilie, { autoClickFirst: false })
          } else {
            pfCollection.appendChild(incomingFamilie)
            BDCollectionPageProductFilterApp.initFamilie(incomingFamilie, { autoClickFirst: true })
            existingByFamilie[familieName] = incomingFamilie
          }
        })

      } catch (err) {
        console.error('[PFExtender]', err)
      }
    }
    return {
      init: initialize
    }
  })();

  var InfluencerLPFeaturedProductApp = (() => {
    var preSelectVariant = () => {
      document.querySelectorAll('.custom-featured-product [data-product-variants]').forEach(variantPicker => {
        const pre_selected_color = variantPicker.getAttribute('data-pre-selected-color');
        const variantButton = variantPicker.querySelector(`[data-swatch-button][data-label="${pre_selected_color}"]`);
        if (variantButton) {
          variantButton.click();
        }
      });
    }
    var initialize = () => {
      if (document.body.classList.contains('template-page') && document.body.classList.contains('template-influencer-lp')) {
        preSelectVariant();
      }
    }
    return {
      init: initialize
    }
  })();

  var TabApp = (() => {
    var open = (container, data_index) => {
      if (!container || !data_index) return;
      container.querySelectorAll('[data-index]').forEach(element => {
        if (element.getAttribute('data-index') === String(data_index)) {
          element.classList.add('active');
        } else {
          element.classList.remove('active');
        }
      });
    }
    var initialize = () => {
      document.querySelectorAll('[js-tab] [js-tab-header]').forEach(element => {
        element.addEventListener('click', () => {
          open(element.closest('[js-tab]'), element.getAttribute('data-index'));
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var PDPShippingInfoApp = (() => {
    var updateVisibility = (container) => {
      if (!container) return;

      let shipping_threshold_value = 0;

      const thresholdSystem = document.querySelector('[js-threshold-system]');
      if (!thresholdSystem) return;

      if (document.body.hasAttribute('shipping-threshold-ab-test-1')) {
        shipping_threshold_value = parseInt(thresholdSystem.getAttribute('data-shipping-threshold-1'));
      } else if (document.body.hasAttribute('shipping-threshold-ab-test-2')) {
        shipping_threshold_value = parseInt(thresholdSystem.getAttribute('data-shipping-threshold-2'));
      }

      const current_variant_price = parseInt(container.getAttribute('data-current-variant-price'));
      if (current_variant_price >= shipping_threshold_value) {
        container.classList.remove('d-none');
      } else {
        container.classList.add('d-none');
      }
    }
    var updateCurrentVariantPrice = (container, price) => {
      if (!container) return;
      container.setAttribute('data-current-variant-price', price);
    }
    var initialize = () => {
      document.querySelectorAll('[js-pdp-shipping-info]').forEach(element => {
        updateVisibility(element);
      });
      document.addEventListener('product:variant-change', (event) => {
        const variant = event.detail.variant;
        if (!variant) return;
        document.querySelectorAll('[js-pdp-shipping-info]').forEach(element => {
          updateCurrentVariantPrice(element, variant.price);
          updateVisibility(element);
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var PDPShippingInfoApp = (() => {
    var updateVisibility = (container) => {
      if (!container) return;

      let shipping_threshold_value = 0;

      const thresholdSystem = document.querySelector('[js-threshold-system]');
      if (!thresholdSystem) return;

      if (document.body.hasAttribute('shipping-threshold-ab-test-1')) {
        shipping_threshold_value = parseInt(thresholdSystem.getAttribute('data-shipping-threshold-1'));
      } else if (document.body.hasAttribute('shipping-threshold-ab-test-2')) {
        shipping_threshold_value = parseInt(thresholdSystem.getAttribute('data-shipping-threshold-2'));
      }

      const current_variant_price = parseInt(container.getAttribute('data-current-variant-price'));
      if (current_variant_price >= shipping_threshold_value) {
        container.classList.remove('d-none');
      } else {
        container.classList.add('d-none');
      }
    }
    var updateCurrentVariantPrice = (container, price) => {
      if (!container) return;
      container.setAttribute('data-current-variant-price', price);
    }
    var initialize = () => {
      document.querySelectorAll('[js-pdp-shipping-info]').forEach(element => {
        updateVisibility(element);
      });
      document.addEventListener('product:variant-change', (event) => {
        const variant = event.detail.variant;
        if (!variant) return;
        document.querySelectorAll('[js-pdp-shipping-info]').forEach(element => {
          updateCurrentVariantPrice(element, variant.price);
          updateVisibility(element);
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var PDPShippingInfoV2App = (() => {
    var mainPriceCents = 0;
    var upsellPriceCents = 0;

    var updateVisibility = (element, price) => {
      if (!element) return;
      const threshold = parseInt(element.getAttribute('data-shipping-threshold'));
      if (isNaN(threshold) || isNaN(price)) return;

      if (price > threshold) {
        element.classList.remove('d-none');
      } else {
        element.classList.add('d-none');
      }
    }
    var refresh = () => {
      const totalPriceCents = mainPriceCents + upsellPriceCents;
      document.querySelectorAll('[js-pdp-shipping-info-v2]').forEach(element => {
        updateVisibility(element, totalPriceCents);
      });
    }
    var initialize = () => {
      const initialContainer = document.querySelector('[js-pdp-shipping-info]');
      if (initialContainer) {
        mainPriceCents = parseInt(initialContainer.getAttribute('data-current-variant-price')) || 0;
      }

      document.addEventListener('product:variant-change', (event) => {
        const variant = event.detail.variant;
        if (!variant) return;
        mainPriceCents = parseInt(variant.price) || 0;
        refresh();
      });

      document.addEventListener('upsell:selection-change', (event) => {
        upsellPriceCents = (event.detail && parseInt(event.detail.priceCents)) || 0;
        refresh();
      });
    }
    return {
      init: initialize
    }
  })();

  var AssemblyInstructionsModalApp = (() => {
    var _open = (modal) => {
      var videoId = modal.getAttribute('data-video-id');
      var videoFrame = modal.querySelector('[js-assembly-instructions-video-frame]');
      if (videoFrame && videoId) {
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube.com/embed/' + videoId + '?rel=0';
        iframe.title = 'YouTube video player';
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        iframe.setAttribute('allowfullscreen', '');
        videoFrame.innerHTML = '';
        videoFrame.appendChild(iframe);
      }
      modal.removeAttribute('aria-hidden');
      modal.classList.add('is-visible');
      document.documentElement.classList.add('assembly-instructions-modal-open');
    }
    var _close = (modal) => {
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('is-visible');
      document.documentElement.classList.remove('assembly-instructions-modal-open');
      var videoFrame = modal.querySelector('[js-assembly-instructions-video-frame]');
      if (videoFrame) {
        videoFrame.innerHTML = '';
      }
    }
    var initialize = () => {
      document.querySelectorAll('[js-assembly-instructions-open]').forEach(button => {
        button.addEventListener('click', () => {
          var modal = document.getElementById(button.getAttribute('aria-controls'));
          if (modal) {
            _open(modal);
          }
        });
      });
      document.querySelectorAll('[js-assembly-instructions-modal]').forEach(modal => {
        modal.querySelectorAll('[js-assembly-instructions-close]').forEach(closeEl => {
          closeEl.addEventListener('click', () => _close(modal));
        });
      });
      document.addEventListener('keydown', (e) => {
        if (e.keyCode !== 27) return;
        document.querySelectorAll('[js-assembly-instructions-modal].is-visible').forEach(modal => _close(modal));
      });
    }
    return {
      init: initialize
    }
  })();

  var App = (() => {
    var initialize = () => {
      CollectionBundleHighlightApp.init();
      AnchorApp.init();
      PDPSizePickerApp.init();
      ProductMeasurementInfoWrapperApp.init();
      ThresholdSystemApp.init();
      CollectionFilterTabApp.init();
      BDProductListSliderApp.init();
      PDPDividedPriceApp.init();
      CartDrawerUpsellApp.init();
      BundleVariantOptionApp.init();
      OrderDeliveryDateApp.init();
      InfluencerLPFeaturedProductApp.init();
      BDCollectionPageProductFilterApp.init(document);
      PFCollectionPageExtenderApp.init();
      TabApp.init();
      PDPShippingInfoApp.init();
      PDPShippingInfoV2App.init();
      AssemblyInstructionsModalApp.init();
      // Initialize custom dropdowns on page load
      initializeCustomDropdowns();
    }
    return {
      init: initialize
    }
  })();


  document.addEventListener('DOMContentLoaded', () => {
    App.init();
    if (!document.body.hasAttribute('pm-8-ab-test')) {
      document.querySelectorAll('.shopify-section:has(>.pm-8-ab-test-b)').forEach(element => {
        element.remove();
      });
    }
  });

})();

const mainCollection = document.querySelector("[js-main-collection]");
if(mainCollection) {
  document.addEventListener("click", function({ target }) {
    const sortByField = mainCollection.querySelector("[js-sort-by-field]");
    if(target.hasAttribute('js-sort-by-item')) {
      const value = target.getAttribute("data-value");
      sortByField.value = value;
      sortByField.dispatchEvent(new Event('input', {'view': window,'bubbles': true}))
      mainCollection.querySelector("[js-sort-by-details]")?.removeAttribute("open")
    };
  });
}